<template>
	<div class="app-toast">
		<toast-message v-for="(item, index) in items" :key="index" :params="item" @hide="hide" />
	</div>
</template>

<script>

import Vue from 'vue'
import Modal from './../../plugins/AppToast';
import ToastMessage from './ToastMessage';

export default {
	components: {
		ToastMessage
	},
	data() {
		return {
			lastID: 1,
			items: []
		}
	},
	methods: {
		show(params) {
			const message = Object.assign(
				{
					id: this.lastID++,
					type: 'alert'
				},
				params
			)
			this.items.push(message)
		},
		hide(params) {
			//this.items = this.items.filter((value) => value.id != params.id)
			this.items.slice(params.idx, 1)
		}
	},
	beforeMount() {
		Modal.EventBus.$on('show', (params) => {
			this.show(params)
		})
	}
}
</script>

<style scoped>
.app-toast {
	position: absolute;
	bottom: 10px;
	right: 10px;
	max-width: 550px;
	z-index: 50;
}
</style>


// WEBPACK FOOTER //
// src/components/alerts/AppToast.vue